/**
 * @generated SignedSource<<64dce6c59a73b1e11f673a3d9c4da0bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TransportType = "BUS" | "PLANE" | "SHIP";
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransport_package$data = {
  readonly defaultArrivalAirport: {
    readonly code: string;
    readonly id: string;
    readonly name: string;
  } | null;
  readonly defaultDepartureAirport: {
    readonly code: string;
    readonly id: string;
    readonly name: string;
  } | null;
  readonly externalFlights: boolean | null;
  readonly id: string;
  readonly services: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly transferPrice: number | null;
  readonly transportName: string | null;
  readonly transportType: TransportType | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlights_package">;
  readonly " $fragmentType": "PackageEditTransport_package";
};
export type PackageEditTransport_package$key = {
  readonly " $data"?: PackageEditTransport_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransport_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransport_package",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transportType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalFlights",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transportName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transferPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Service",
      "kind": "LinkedField",
      "name": "services",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Airport",
      "kind": "LinkedField",
      "name": "defaultDepartureAirport",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Airport",
      "kind": "LinkedField",
      "name": "defaultArrivalAirport",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlights_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "20ab47c99dc0bfa75bd8c7f5eeafb27d";

export default node;
